import { makeStyles } from "@material-ui/core/styles";
import React, { useContext, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
import style from "../ThemesLayout.module.css";
import styles from "./CustomTheme.module.css";
import AdvanceThemeJson from "./ThemePropertiesJson/AdvanceThemeJson";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../../../Resources/CanvasContextFile";
import MultiSelectCustom from "./MultiSelectCustom";
import Button from "@material-ui/core/Button";
import { GetStateFromData } from "../../../../CustomHooks/CustomHooks";

const useStyles = makeStyles({
  multiselect: {
    "& button": {
      width: "271px !important",
      height: "28px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      border: "1px solid #D3D3D3",
      fontWeight: "500",
      fontSize: "14px",
      fontFamily: "Open-Sans",
      letterSpacing: "0px",
      color: "#6B6B6B",
      opacity: "1",
      paddingBottom: "10px",
      boxShadow: "0px 0px 3px #00000029",
      borderRadius: "2px",
    },
    "&:first-child > nth-child(2) > first-child": {
      width: "300px !important",
    },
  },
});

const CustomTheme = (props) => {
  const contexts = GetStateFromData(props.containerId);

  const { updateJson, showAlertConfirmNotifications } = contexts.contexts;

  const { updatedComponentInFormState } = updateJson;
  const inputFile = useRef(null);

  const onButtonClick = (evt) => {
    inputFile.current.click();
  };

  const { t } = useTranslation(["styles", "translation"]);

  const advThemeJson = AdvanceThemeJson["controlsList"];
  const [selectedControl, setSelectedControl] = useState("Application");
  const classes = useStyles();
  const [controls, setControls] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [selectedCustomControl, setSelectedCustomControl] = useState("");

  const [selectedInputCustomControl, setSelectedInputCustomControl] =
    useState("");    
  const isProcessForm = window?.location?.href?.includes("psh/pmWebDesigner")
  function controlData(value, inputControl) {
    setSelectedCustomControl("");
    setSelectedInputCustomControl(inputControl);
    setSelectedCustomControl(value);
  }

  function uploadCSSFile(evt) {
    try {
      let files = evt.target.files;
      if (!files.length) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: "NO_FILE",
        });
        return;
      }
      let file = files[0];
      let reader = new FileReader();
      const self = this;
      reader.onload = (event) => {
        props.formData.theme["ApplicationTheme"] = event.target.result;
        updatedComponentInFormState();
      };
      reader.readAsText(file);
    } catch (err) {
      console.error(err);
    }
  }

  const handleSave = (arg) => {
    if (selectedControl === "Application") {
      props.formData.theme["ApplicationTheme"] = selectedCustomControl;
    } else if (selectedControl === "Inputs") {
      if (selectedInputCustomControl === "textbox") {
        props.formData.theme["TextBoxCustomStyle"] = selectedCustomControl;
      } else if (selectedInputCustomControl === "radio") {
        props.formData.theme["RadioCustomStyle"] = selectedCustomControl;
      } else if (selectedInputCustomControl === "checkbox") {
        props.formData.theme["CheckBoxCustomStyle"] = selectedCustomControl;
      } else if (selectedInputCustomControl === "toggle") {
        props.formData.theme["ToggleCustomStyle"] = selectedCustomControl;
      }
    } else if (selectedControl === "Button") {
      props.formData.theme["ButtonCustomStyle"] = selectedCustomControl;
    } else if (selectedControl === "Sections") {
      props.formData.theme["SectionsCustomStyle"] = selectedCustomControl;
    } else if (selectedControl === "Label") {
      props.formData.theme["LabelCustomStyle"] = selectedCustomControl;
    } else if (selectedControl === "Horizontal Tabs") {
      props.formData.theme["HorizontalTabs"] = selectedCustomControl;
    } else if (selectedControl === "Vertical Tabs") {
      props.formData.theme["VerticalTabs"] = selectedCustomControl;
    } else if (selectedControl === "Horizontal Wizard") {
      props.formData.theme["HorizontalWizard"] = selectedCustomControl;
    } else if (selectedControl === "Vertical Wizard") {
      props.formData.theme["VerticalWizard"] = selectedCustomControl;
    } else if (selectedControl === "Tables") {
      props.formData.theme["Tables"] = selectedCustomControl;
    } else if (selectedControl === "Doc List") {
      props.formData.theme["DocList"] = selectedCustomControl;
    }

    props.formData.theme["CustomStyle"] = "";
    if (props.formData.theme["TextBoxCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["TextBoxCustomStyle"] + " ";
    }
    if (props.formData.theme["RadioCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["RadioCustomStyle"] + " ";
    }
    if (props.formData.theme["CheckBoxCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["CheckBoxCustomStyle"] + " ";
    }
    if (props.formData.theme["ToggleCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["ToggleCustomStyle"] + " ";
    }
    if (props.formData.theme["ApplicationTheme"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["ApplicationTheme"] + " ";
    }
    if (props.formData.theme["ButtonCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["ButtonCustomStyle"] + " ";
    }
    if (props.formData.theme["SectionsCustomStyle"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["SectionsCustomStyle"] + " ";
    }
    if (props.formData.theme["HorizontalTabs"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["HorizontalTabs"] + " ";
    }
    if (props.formData.theme["VerticalTabs"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["VerticalTabs"] + " ";
    }
    if (props.formData.theme["HorizontalWizard"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["HorizontalWizard"] + " ";
    }
    if (props.formData.theme["VerticalWizard"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["VerticalWizard"] + " ";
    }
    if (props.formData.theme["Tables"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["Tables"] + " ";
    }
    if (props.formData.theme["DocList"] !== undefined) {
      props.formData.theme["CustomStyle"] +=
        props.formData.theme["DocList"] + " ";
    }
    updatedComponentInFormState();

    showAlertConfirmNotifications({
      open: true,
      showConfirm: "showNotification",
      alertType: "success",
      alertContentKey: "Custom_Theme_Saved",
    });
  };

  return (
    <div className={style.themeRoot}  style={{height:isProcessForm ? `calc(100vh - 56px - ${props?.headerHeight}px)` : `calc(100vh - 48px - 56px - ${props?.headerHeight}px)`,overflow:"unset"}}>
      <Col
        className={["col", style.advanceThemeControlOptions].join(" ")}
        style={{ paddingRight: "0px !important" }}
      >
        {AdvanceThemeJson && AdvanceThemeJson["controlsList"] ? (
          Object.keys(AdvanceThemeJson["controlsList"]).map(
            (control, index) => {
              return (
                control !== "Application" && (
                  <div
                    className={[
                      style.advanceThemeControl,
                      selectedControl === control
                        ? style.selectedStyleImgDiv
                        : null,
                    ].join(" ")}
                  >
                    <Col
                      className={style.advanceThemeSquareBoxParent}
                      onClick={() => setSelectedControl(control)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setSelectedControl(control);
                        }
                      }}
                    >
                      <img
                        src={
                          (
                            AdvanceThemeJson["controlsList"] &&
                            AdvanceThemeJson["controlsList"][control] &&
                            AdvanceThemeJson["controlsList"][control][
                              "imgSrc"
                            ] &&
                            AdvanceThemeJson["controlsList"][control]["imgSrc"]
                          ).default
                        }
                        className={[style.squareBoxIconTheme].join("")}
                        alt="Square Box Icon"
                      />
                    </Col>
                    <Col
                      className={[
                        style.advanceThemeControlName,
                        selectedControl === control ? style.selectedText : null,
                      ].join(" ")}
                      onClick={() => setSelectedControl(control)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setSelectedControl(control);
                        }
                      }}
                    >
                      {t(`translation:${control}`)}
                    </Col>
                  </div>
                )
              );
            }
          )
        ) : (
          <></>
        )}
      </Col>
      <Col
        className={[
          "col-sm-12",
          style.advanceThemeControlThemeDescription,
        ].join(" ")}
      >
        {selectedControl === "Application" ? (
          <>
            <div className={styles.customcssdiv}>
              <span
                className={styles.customCSSHeading}
                style={{ textAlign: t("styles:customThemeTextAlign") }}
              >
                {t("translation:Custom CSS on Forms")}
              </span>
              <button
                className={styles.importCSSButton}
                style={{ float: t("styles:customThemeFloat") }}
                onClick={onButtonClick}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onButtonClick(e);
                  }
                }}
              >
                {t("translation:Import CSS")}
              </button>
              <input
                aria-label={"Upload CSS File"}
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: "none" }}
                onChange={(e) => uploadCSSFile(e)}
              />
            </div>

            <div className={styles.para1}>
              <div style={{ width: "315px" }}>
                {t(
                  "translation:* Please note Custom CSS on application will be applied on all the pages within an application."
                )}
              </div>
            </div>

            <textarea
              aria-label="ApplicationTheme"
              className={styles.textareaClassCustom}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["ApplicationTheme"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Inputs" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Input Custom CSS")}
            </div>

            <div className={styles.dropdownMultiselect}>
              <div
                className={
                  styles.dropdownMultiselect2 + " " + classes.multiselect
                }
              >
                <MultiSelectCustom
                  selectedOptions={selectedOptions}
                  setSelectedOptions={setSelectedOptions}
                  setSelectedCustomControl={setSelectedCustomControl}
                />
              </div>

              {selectedOptions.includes("Textbox") ? (
                <>
                  <div className={styles.controlStyleCustom}>
                    {t("translation:Textbox CSS")}
                  </div>
                  <textarea
                    aria-label="TextboxCustom Style"
                    className={styles.textareaClassCustomControl}
                    defaultValue={
                      props.formData.theme &&
                      props.formData.theme["TextBoxCustomStyle"]
                    }
                    onBlur={(event) =>
                      controlData(event.target.value, "textbox")
                    }
                  ></textarea>
                </>
              ) : null}

              {selectedOptions.includes("Radio") ? (
                <>
                  <div className={styles.controlStyleCustom}>
                    {t("translation:Radio CSS")}
                  </div>
                  <textarea
                    aria-label="Radio Custom Style"
                    className={styles.textareaClassCustomControl}
                    onBlur={(event) => controlData(event.target.value, "radio")}
                    defaultValue={
                      props.formData.theme &&
                      props.formData.theme["RadioCustomStyle"]
                    }
                  ></textarea>
                </>
              ) : null}

              {selectedOptions.includes("Checkbox") ? (
                <>
                  <div className={styles.controlStyleCustom}>
                    {t("translation:Checkbox CSS")}
                  </div>
                  <textarea
                    aria-label="Checkbox Custom Style"
                    className={styles.textareaClassCustomControl}
                    onBlur={(event) =>
                      controlData(event.target.value, "checkbox")
                    }
                    defaultValue={
                      props.formData.theme &&
                      props.formData.theme["CheckBoxCustomStyle"]
                    }
                  ></textarea>
                </>
              ) : null}

              {selectedOptions.includes("Toggle") ? (
                <>
                  <div className={styles.controlStyleCustom}>
                    {t("translation:Toggle CSS")}
                  </div>
                  <textarea
                    aria-label="Toggle Custom Style"
                    className={styles.textareaClassCustomControl}
                    onBlur={(event) =>
                      controlData(event.target.value, "toggle")
                    }
                    defaultValue={
                      props.formData.theme &&
                      props.formData.theme["ToggleCustomStyle"]
                    }
                  ></textarea>
                </>
              ) : null}
            </div>
          </>
        ) : null}

        {selectedControl === "Button" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Button Custom CSS")}
            </div>
            <textarea
              aria-label="Button Custom Style"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme &&
                props.formData.theme["ButtonCustomStyle"]
              }
            ></textarea>
          </>
        ) : null}
        {selectedControl === "Label" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Label Custom CSS")}
            </div>
            <textarea
              aria-label="Label Custom Style"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["LabelCustomStyle"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Sections" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Section Custom CSS")}
            </div>
            <textarea
              aria-label="Section Custom Style"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme &&
                props.formData.theme["SectionsCustomStyle"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Horizontal Tabs" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Horizontal Tabs Custom CSS")}
            </div>
            <textarea
              aria-label="Horizontal Tabs"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["HorizontalTabs"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Vertical Tabs" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Vertical Tabs Custom CSS")}
            </div>
            <textarea
              aria-label="Vertical Tabs"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["VerticalTabs"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Horizontal Wizard" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Horizontal Wizard Custom CSS")}
            </div>
            <textarea
              aria-label="Horizontal Wizard"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["HorizontalWizard"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Vertical Wizard" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Vertical Wizard Custom CSS")}
            </div>
            <textarea
              aria-label="Vertical Wizard"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["VerticalWizard"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Tables" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Tables Custom CSS")}
            </div>
            <textarea
              aria-label="Tables"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["Tables"]
              }
            ></textarea>
          </>
        ) : null}

        {selectedControl === "Doc List" ? (
          <>
            <div className={styles.InputcustomCSSHeading}>
              {" "}
              {t("translation:Doc List Custom CSS")}
            </div>
            <textarea
              aria-label="Doc List"
              className={styles.textareaClassCustomControl}
              onBlur={(event) => controlData(event.target.value)}
              defaultValue={
                props.formData.theme && props.formData.theme["DocList"]
              }
            ></textarea>
          </>
        ) : null}
      </Col>

      <Row className={style.themeFooter}>
        <Button
          disableFocusRipple
          disableRipple
          tabIndex={0}
          className={[
            style.themeFooterButtons,
            style.saveButton,
            "formBuilder-MuiButton-outlined",
          ].join(" ")}
          onClick={() => handleSave("save")}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSave("save");
            }
          }}
        >
          {t("translation:Save")}
        </Button>

        <Button
          disableFocusRipple
          disableRipple
          tabIndex={0}
          className={[
            style.themeFooterButtons,
            style.saveAsButton,
            "formBuilder-MuiButton-outlined",
          ].join(" ")}
          onClick={()=>props?.setShowThemeNameBackdrop(true)}
        >
          {" "}
          {t("translation:SaveAs")}
        </Button>
      </Row>
    </div>
  );
};

export default CustomTheme;
